import React from 'react';
import styles from './spinner.css';

const Loading = () => {
    return (
        <div className={styles.container}>
            <div className={styles.logo}>
            </div>
        </div>
    );
};

export default Loading;
